import { createHttpLink } from '@apollo/client';
import { isClientOriginOrPathZillow } from 'src/utils/validators/isClientOriginOrPathZillow';

const createAPILink = () =>
    createHttpLink({
        uri: isClientOriginOrPathZillow() ? '/homeloans/mortgage/api/graphql' : '/api/mortgage/graphql',
    });

export { createAPILink };
